module.exports = __webpack_public_path__ + "product_search_favourites-c4c07356f0ed0c31a381e5d5ae29a477.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/common/onboarding/product_search_favourites.png
// module id = 1138
// module chunks = 0 1 2 3 4